export default __webpack_public_path__ + "static/media/34I-18656_-14532_0.a5fa9066.jpg";